const asyncFormSubmit = async (element) => {
  const url = new URL(element.action);
  const params = new URLSearchParams(new FormData(element));
  url.search = params.toString();

  try {
    const response = await fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const html = await response.text();
    Turbo.renderStreamMessage(html);
  } catch (error) {
    console.error('Fetch error:', error);
  }
};

export default asyncFormSubmit;
